import React from "react";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import UnapprovedInvoiceTable from "../unapprovedInvoices/components/UnapprovedInvoiceTable";
import PostedInvoicesTable from "pages/commercialDocuments/components/PostedInvoicesTable";
import HeaderContent from "../../components/layout/components/HeaderContent";
import ExportCommercialDocumentButton from "../commercialDocuments/components/ExportCommercialDocumentButton";
import { availableOnlySuperAdmin } from "utils/validation";

const InvoiceList = () => {
  const breadcrumb = [{ link: "/invoices", title: "Invoices" }];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Invoices"
        isNotHaveSchoolFilter
      />

      <SanitizedGrid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h6">Financial Information</Typography>
        </Grid>
        <Grid item xs={6}>
          {availableOnlySuperAdmin() && (
            <ExportCommercialDocumentButton documentType="Invoice" />
          )}
        </Grid>

        <Grid item xs={8}>
          <Typography variant="h6">Unapproved Invoice</Typography>
        </Grid>
        <Grid item xs={4}></Grid>

        <Grid item xs={12}>
          <UnapprovedInvoiceTable />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Approved Invoices</Typography>
        </Grid>

        <Grid item xs={12}>
          <PostedInvoicesTable />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default InvoiceList;
